import { useState } from 'react';

const STORAGE_PREFIX = 'pageSize:';

/**
 * Bir tablonun sayfa boyutu tercihini localStorage'da hatırlar (key bazında).
 * Kullanıcı 15'ten 100'e çıkarıp başka bir sayfaya gidip geri döndüğünde
 * sabit varsayılana sıfırlanmasın diye.
 */
const usePersistedPageSize = (key, defaultSize = 15) => {
  const [pageSize, setPageSizeState] = useState(() => {
    const stored = localStorage.getItem(STORAGE_PREFIX + key);
    const parsed = stored ? parseInt(stored, 10) : NaN;
    return Number.isFinite(parsed) && parsed > 0 ? parsed : defaultSize;
  });

  const setPageSize = (size) => {
    setPageSizeState(size);
    localStorage.setItem(STORAGE_PREFIX + key, String(size));
  };

  return [pageSize, setPageSize];
};

export default usePersistedPageSize;
